<template>
    <div>
        <div id="emailSubmissionModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="emailSubmissionTitle" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="emailSubmissionTitle">Submit by Secure Email</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>                        
                    </div>
                    <div class="modal-body">
                        <div v-if="message" :class="['alert alert-dismissible fade show alert-condensed', alertClass ]" role="alert">
                            <span class="alert-message">{{ message }}</span>
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>                        
                        </div>                    
                        <div class="mt-1">
                            <span class="font-weight-bold">Submit To:</span>                   
                            <div v-if="recipients.length">
                                <div v-for="(recipient, index) in recipients" :key="'email-submission-recipient-' + index" class="pl-3">
                                    <div class="d-flex flex-row">
                                        <div class="flex-auto text-truncate" :title="recipient.name">
                                            {{ recipient.name }}
                                        </div>
                                        <div class="flex-fill ml-2">
                                            <input v-if="recipient.edit" type="email" class="form-control form-control-sm" placeholder="Email Address" v-model="recipient.email" @blur="changeEmailAddress(recipient)" @keyup.enter="$event.target.blur()" v-focus>
                                            <span v-else @click="recipient.edit = true;">
                                                {{ recipient.email }}
                                                <a href="javascript:void(0)" title="Edit Email Address"><i class="fas fa-pencil-alt fa-xs"></i></a>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="h4 text-center text-muted">No recipients.</div>
                        </div>                    
                        <div class="mt-2">
                            <span class="font-weight-bold">Documents:</span>
                            <div v-for="document in documents" class="text-truncate pl-3" :key="'document-' + document.id" :title="document.document_type.name + ' - ' + document.description">
                                {{ document.document_type.name }} - {{ document.description }}
                            </div>
                        </div>                                 
                    </div>
                    <div class="modal-body border-top pt-1">             
                        <div class="d-flex mt-3">
                            <div class="dropdown">
                                <button class="btn btn-sm btn-primary dropdown-toggle" title="Add Attachment" data-toggle="dropdown">
                                    <i class="fas fa-paperclip fa-lg"></i>
                                </button>
                                <div class="dropdown-menu float-above">
                                    <a class="dropdown-item" href="javascript:void(0)" @click="showClaimDocuments()">Browse Claim Documents...</a>
                                    <a class="dropdown-item" href="javascript:void(0)" @click="upload()">Browse Computer...</a>                                        
                                </div>
                            </div>
                            <div class="instructions text-muted px-2">
                                Click the paperclip button to add attachments from available claim documents or browse for a file on your computer. 
                            </div>
                        </div>
                        <div :class="['mt-1 pl-1', { 'border-top': attachments.length }]">
                            <div v-for="attachment in attachments" class="d-flex flex-row" :key="'submission-attachment-' + attachment.id">
                                <div class="pr-1">                                 
                                    <a href="javascript:void(0)" class="remove-button" title="Remove Attachment" @click="removeAttachment(attachment.id)">
                                        <i class="fas fa-minus-circle fa-xs"></i>
                                    </a>
                                </div>                                
                                <div class="text-truncate" :title="attachment.document_type.name + ' - ' + attachment.description">
                                    {{ attachment.document_type.name + ' - ' + attachment.description }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body border-top pt-1">                  
                        <div class="d-flex flex-row mt-3">
                            <div>
                                <button type="button" class="btn btn-primary btn-sm" @click="visible = !visible">
                                    <span class="font-weight-bold">CC</span>
                                </button>
                            </div>
                            <div v-if="visible" class="px-2">
                                <div class="d-flex flex-row">
                                    <div class="flex-grow-1 mr-1">
                                        <input type="text" class="form-control form-control-sm" list="contact-options" Placeholder="Name" :value="cc_recipient.name" @input="onInput($event.target.value)">
                                        <datalist id="contact-options">
                                            <option v-for="contact in contacts" :key="contact.id" :value="contact.full_name" v-text="contact.full_name"></option>
                                        </datalist>
                                    </div>
                                    <div class="mr-1">
                                        <input type="email" class="form-control form-control-sm" placeholder="Email Address" v-model="cc_recipient.email">
                                    </div>
                                    <div>
                                        <button type="button" class="btn btn-primary btn-sm" @click="addCC()" :disabled="!(cc_recipient.name && cc_recipient.email)">Add</button>
                                    </div>
                                </div>
                                <div v-if="ccMessage" class="text-danger">{{ ccMessage }}</div>
                            </div>
                            <div v-else class="instructions text-muted px-2">
                                Click the CC button to add carbon copy recipients. These will only be sent once the document has been
                                successfully sent to the primary recipient.
                            </div>
                        </div>             
                        <div :class="['mt-1 pl-1', { 'border-top': cc_recipients.length }]"> 
                            <div v-for="(cc, index) in cc_recipients" class="d-flex flex-row" :key="cc.email + '-' + index">
                                <div class="pr-1">
                                    <a href="javascript:void(0)" class="btn btn-link p-0 remove-button" title="Remove" @click="removeCC(cc.name, cc.email)">
                                        <i class="fas fa-minus-circle fa-xs"></i>
                                    </a>                                
                                </div>                            
                                <div class="flex-fill text-truncate pr-1" :title="cc.name">{{ cc.name }}</div>
                                <div class="text-nowrap">{{ cc.email }}</div>
                            </div>
                        </div>
                    </div>                                
                    <div class="modal-footer">
                        <button class="btn btn-primary" @click="send()" :disabled="recipients.length < 1">Submit</button>
                        <button class="btn btn-secondary" @click="cancel()">Cancel</button>                    
                    </div>
                </div>
            </div>
        </div>
    </div>     
</template>

<script>
import { DocumentType, TransmissionType } from '../../constants.js';

export default {
    props: {
        claimId: Number
    },
    data() {
        return {

            // import constants into the template
            DocumentType: DocumentType,
            TransmissionType: TransmissionType,

            documents: [],
            recipients: [],
            cc_recipients: [],
            attachments: [],
            contacts: [],
            options: [],
            cc_recipient: {
                name: null,
                email: null
            },
            visible: false,
            ccMessage: null,        
            alertClass: 'alert-danger'
        }
    }, 
    computed: {
        message: function () {
            return (this.recipients.length) ? null : 'No recipients have been specified. Ensure a payer email has been entered for the claim.';
        }
    }, 
    methods: {
        show: function (documentTypeId, documents) {

            // reset data attributes
            this.documentTypeId = documentTypeId;            
            this.documents = documents;
            this.recipients = [];
            this.cc_recipients = [];
            this.attachments = [];
            this.contacts = [];
            this.options = [];
            this.cc_recipient = {
                name: null,
                email: null
            };
            this.visible = false;          

            axios.get('/ajax/claims/' + this.claimId + '/email-init', {
                params: {
                    document_type_id: this.documentTypeId,
                    document_ids: this.documents.map(e => e.id)
                }             
            })
            .then(response => {
                this.recipients = response.data.recipients.map(e => { this.$set(e,'edit',false); return e; });
                this.attachments = response.data.attachments;
                this.cc_recipients = response.data.cc;
                this.contacts = response.data.contacts;
                this.options = response.data.options;

                $('#emailSubmissionModal').modal('show'); 
            })
            .catch(error => {
                toastr['error'](error, null, { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
            });
        },
        cancel: function () {
            $('#emailSubmissionModal').modal('hide');
        },
        changeEmailAddress: function (recipient) {
            if (recipient.edit) {
                recipient.edit = false;
                this.$emit('update');
            }            
        },        
        send: function () {

            axios.post('/ajax/claims/' + this.claimId + '/email-submit', {
                document_type_id: this.documentTypeId,
                documents: this.documents,
                attachments: this.attachments,
                recipients: this.recipients,
                cc: this.cc_recipients
            })
            .then(response => {
                if (response.data.message) {
                    toastr['success'](response.data.message, null, { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
                }
                $('#emailSubmissionModal').modal('hide');
            })
            .catch(error => {
                toastr['error'](error.response.data.message, null, { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
                $('#emailSubmissionModal').modal('hide');
            });
        },
        onInput: function (value) {

            let contact = this.contacts.find(o => o.full_name.toUpperCase() === value.toUpperCase());
            if (contact) {
                this.cc_recipient.name = contact.full_name;
                this.cc_recipient.email = contact.email;
            }
            else {
                this.cc_recipient.name = value;
            }
        }, 
        addCC: function () {

            if (!this.cc_recipient.name.trim()) {
                this.ccMessage = "Name is a required field and cannot be blank.";
                return;
            }

            if (!this.cc_recipient.email.trim()) {
                this.ccMessage = "Email Address is a required field and cannot be blank.";
                return;
            }            

            let exists = this.cc_recipients.some(e => e.email === this.cc_recipient.email);
            if (!exists && this.cc_recipient.email) {
                this.cc_recipients.push({ 
                    name: this.cc_recipient.name,
                    email: this.cc_recipient.email
                });
            }

            this.cc_recipient = {
                name: null,
                email: null
            };

            this.visible = false;
            this.ccMessage = null;
        },
        removeCC: function (name, email) {
            this.cc_recipients = this.cc_recipients.filter(e => !(e.name === name && e.email === email));
        },
        upload: function () {
            $('#emailSubmissionModal').modal('hide');
            eventHub.$emit('show-attachment-upload', this.options, DocumentType.COVER_SHEET, this.addAttachment, 'email-submission-visible');
        },                 
        showClaimDocuments: function () {
            $('#emailSubmissionModal').modal('hide');

            // get the ids of the documents we are submitting so we can pre-select in the attachments
            let preselected = this.attachments.map(e => e.id);
            eventHub.$emit('show-add-attachments', this.documentTypeId, preselected, this.addAttachments, 'email-submission-visible');
        },
        addAttachment: function (document) {
            this.attachments.push(document);
        },            
        addAttachments: function (selectedDocuments) {
            this.attachments = selectedDocuments;
        },
        removeAttachment: function (id) {
            this.attachments = this.attachments.filter(e => e.id != id);
        }              
    },
    created() {
        eventHub.$on('show-email-submission', this.show);
        eventHub.$on('email-submission-visible', function () { 
            $('#emailSubmissionModal').modal('show'); 
        });         
    },
    beforeDestroy() {
        eventHub.$off('show-email-submission');
        eventHub.$off('email-submission-visible');       
    },
    directives: {
        focus: {
            inserted: function (el) {
                el.focus();
            }
        }
    }         
}
</script>

<style scoped>
    .remove-button {
        position: relative;
        top: -5px;
    }

    .instructions {
        line-height: 1em;
        font-size: .90em;
        font-style: italic;;
    }    

    .attachment-icon {
        position: relative;
        top: -3px;
    }    
</style>